/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";

export const protobufPackage = "Reality.Reality.Api";

export interface GachaGetEmissionItemListRequest {
  gachaId: number;
  /** レア度以上確定時のウェイトセットID */
  rarityGuaranteeWeightSetId?: number | undefined;
}

export interface GachaGetEmissionItemListResponse {
  gachaItems: GachaGetEmissionItemListResponse_GachaItemEmissionRate[];
  rarityRates: GachaGetEmissionItemListResponse_GachaRarityRate[];
}

/** ガチャアイテム排出率 */
export interface GachaGetEmissionItemListResponse_GachaItemEmissionRate {
  /** ガチャアイテム排出確率（％） */
  emissionRate: number;
  /** アイテムレア数 */
  rarity: number;
  /** ガチャアイテムID */
  itemId: number;
  /** アイテム表示名称 */
  name: string;
  partsSets: GachaGetEmissionItemListResponse_GachaItemEmissionRate_PartsSet[];
}

/** アバターパーツセット情報 */
export interface GachaGetEmissionItemListResponse_GachaItemEmissionRate_PartsSet {
  /** パーツセットID */
  id: number;
  /** 色情報ID(数字4文字) */
  colorId: string;
  /** 体型情報(F001,M001など英1文字+数字3文字) */
  original: string;
  /** アイテムの表示上扱う画像URL */
  itemImageUrl: string;
}

export interface GachaGetEmissionItemListResponse_GachaRarityRate {
  /** レア度 */
  rarity: number;
  /** レア度排出確率（％） */
  emissionRate: number;
}

function createBaseGachaGetEmissionItemListRequest(): GachaGetEmissionItemListRequest {
  return { gachaId: 0, rarityGuaranteeWeightSetId: undefined };
}

export const GachaGetEmissionItemListRequest = {
  encode(message: GachaGetEmissionItemListRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.gachaId !== 0) {
      writer.uint32(8).int64(message.gachaId);
    }
    if (message.rarityGuaranteeWeightSetId !== undefined) {
      writer.uint32(16).int64(message.rarityGuaranteeWeightSetId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GachaGetEmissionItemListRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGachaGetEmissionItemListRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.gachaId = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.rarityGuaranteeWeightSetId = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GachaGetEmissionItemListRequest {
    return {
      gachaId: isSet(object.gachaId) ? globalThis.Number(object.gachaId) : 0,
      rarityGuaranteeWeightSetId: isSet(object.rarityGuaranteeWeightSetId)
        ? globalThis.Number(object.rarityGuaranteeWeightSetId)
        : undefined,
    };
  },

  toJSON(message: GachaGetEmissionItemListRequest): unknown {
    const obj: any = {};
    if (message.gachaId !== 0) {
      obj.gachaId = Math.round(message.gachaId);
    }
    if (message.rarityGuaranteeWeightSetId !== undefined) {
      obj.rarityGuaranteeWeightSetId = Math.round(message.rarityGuaranteeWeightSetId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GachaGetEmissionItemListRequest>, I>>(base?: I): GachaGetEmissionItemListRequest {
    return GachaGetEmissionItemListRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GachaGetEmissionItemListRequest>, I>>(
    object: I,
  ): GachaGetEmissionItemListRequest {
    const message = createBaseGachaGetEmissionItemListRequest();
    message.gachaId = object.gachaId ?? 0;
    message.rarityGuaranteeWeightSetId = object.rarityGuaranteeWeightSetId ?? undefined;
    return message;
  },
};

function createBaseGachaGetEmissionItemListResponse(): GachaGetEmissionItemListResponse {
  return { gachaItems: [], rarityRates: [] };
}

export const GachaGetEmissionItemListResponse = {
  encode(message: GachaGetEmissionItemListResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.gachaItems) {
      GachaGetEmissionItemListResponse_GachaItemEmissionRate.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    for (const v of message.rarityRates) {
      GachaGetEmissionItemListResponse_GachaRarityRate.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GachaGetEmissionItemListResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGachaGetEmissionItemListResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.gachaItems.push(
            GachaGetEmissionItemListResponse_GachaItemEmissionRate.decode(reader, reader.uint32()),
          );
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.rarityRates.push(GachaGetEmissionItemListResponse_GachaRarityRate.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GachaGetEmissionItemListResponse {
    return {
      gachaItems: globalThis.Array.isArray(object?.gachaItems)
        ? object.gachaItems.map((e: any) => GachaGetEmissionItemListResponse_GachaItemEmissionRate.fromJSON(e))
        : [],
      rarityRates: globalThis.Array.isArray(object?.rarityRates)
        ? object.rarityRates.map((e: any) => GachaGetEmissionItemListResponse_GachaRarityRate.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GachaGetEmissionItemListResponse): unknown {
    const obj: any = {};
    if (message.gachaItems?.length) {
      obj.gachaItems = message.gachaItems.map((e) => GachaGetEmissionItemListResponse_GachaItemEmissionRate.toJSON(e));
    }
    if (message.rarityRates?.length) {
      obj.rarityRates = message.rarityRates.map((e) => GachaGetEmissionItemListResponse_GachaRarityRate.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GachaGetEmissionItemListResponse>, I>>(
    base?: I,
  ): GachaGetEmissionItemListResponse {
    return GachaGetEmissionItemListResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GachaGetEmissionItemListResponse>, I>>(
    object: I,
  ): GachaGetEmissionItemListResponse {
    const message = createBaseGachaGetEmissionItemListResponse();
    message.gachaItems =
      object.gachaItems?.map((e) => GachaGetEmissionItemListResponse_GachaItemEmissionRate.fromPartial(e)) || [];
    message.rarityRates =
      object.rarityRates?.map((e) => GachaGetEmissionItemListResponse_GachaRarityRate.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGachaGetEmissionItemListResponse_GachaItemEmissionRate(): GachaGetEmissionItemListResponse_GachaItemEmissionRate {
  return { emissionRate: 0, rarity: 0, itemId: 0, name: "", partsSets: [] };
}

export const GachaGetEmissionItemListResponse_GachaItemEmissionRate = {
  encode(
    message: GachaGetEmissionItemListResponse_GachaItemEmissionRate,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.emissionRate !== 0) {
      writer.uint32(9).double(message.emissionRate);
    }
    if (message.rarity !== 0) {
      writer.uint32(16).int64(message.rarity);
    }
    if (message.itemId !== 0) {
      writer.uint32(24).int64(message.itemId);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    for (const v of message.partsSets) {
      GachaGetEmissionItemListResponse_GachaItemEmissionRate_PartsSet.encode(v!, writer.uint32(42).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GachaGetEmissionItemListResponse_GachaItemEmissionRate {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGachaGetEmissionItemListResponse_GachaItemEmissionRate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 9) {
            break;
          }

          message.emissionRate = reader.double();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.rarity = longToNumber(reader.int64() as Long);
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.itemId = longToNumber(reader.int64() as Long);
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.partsSets.push(
            GachaGetEmissionItemListResponse_GachaItemEmissionRate_PartsSet.decode(reader, reader.uint32()),
          );
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GachaGetEmissionItemListResponse_GachaItemEmissionRate {
    return {
      emissionRate: isSet(object.emissionRate) ? globalThis.Number(object.emissionRate) : 0,
      rarity: isSet(object.rarity) ? globalThis.Number(object.rarity) : 0,
      itemId: isSet(object.itemId) ? globalThis.Number(object.itemId) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      partsSets: globalThis.Array.isArray(object?.partsSets)
        ? object.partsSets.map((e: any) => GachaGetEmissionItemListResponse_GachaItemEmissionRate_PartsSet.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GachaGetEmissionItemListResponse_GachaItemEmissionRate): unknown {
    const obj: any = {};
    if (message.emissionRate !== 0) {
      obj.emissionRate = message.emissionRate;
    }
    if (message.rarity !== 0) {
      obj.rarity = Math.round(message.rarity);
    }
    if (message.itemId !== 0) {
      obj.itemId = Math.round(message.itemId);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.partsSets?.length) {
      obj.partsSets = message.partsSets.map((e) =>
        GachaGetEmissionItemListResponse_GachaItemEmissionRate_PartsSet.toJSON(e)
      );
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GachaGetEmissionItemListResponse_GachaItemEmissionRate>, I>>(
    base?: I,
  ): GachaGetEmissionItemListResponse_GachaItemEmissionRate {
    return GachaGetEmissionItemListResponse_GachaItemEmissionRate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GachaGetEmissionItemListResponse_GachaItemEmissionRate>, I>>(
    object: I,
  ): GachaGetEmissionItemListResponse_GachaItemEmissionRate {
    const message = createBaseGachaGetEmissionItemListResponse_GachaItemEmissionRate();
    message.emissionRate = object.emissionRate ?? 0;
    message.rarity = object.rarity ?? 0;
    message.itemId = object.itemId ?? 0;
    message.name = object.name ?? "";
    message.partsSets =
      object.partsSets?.map((e) => GachaGetEmissionItemListResponse_GachaItemEmissionRate_PartsSet.fromPartial(e)) ||
      [];
    return message;
  },
};

function createBaseGachaGetEmissionItemListResponse_GachaItemEmissionRate_PartsSet(): GachaGetEmissionItemListResponse_GachaItemEmissionRate_PartsSet {
  return { id: 0, colorId: "", original: "", itemImageUrl: "" };
}

export const GachaGetEmissionItemListResponse_GachaItemEmissionRate_PartsSet = {
  encode(
    message: GachaGetEmissionItemListResponse_GachaItemEmissionRate_PartsSet,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.id !== 0) {
      writer.uint32(8).int64(message.id);
    }
    if (message.colorId !== "") {
      writer.uint32(18).string(message.colorId);
    }
    if (message.original !== "") {
      writer.uint32(26).string(message.original);
    }
    if (message.itemImageUrl !== "") {
      writer.uint32(34).string(message.itemImageUrl);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number,
  ): GachaGetEmissionItemListResponse_GachaItemEmissionRate_PartsSet {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGachaGetEmissionItemListResponse_GachaItemEmissionRate_PartsSet();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.colorId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.original = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.itemImageUrl = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GachaGetEmissionItemListResponse_GachaItemEmissionRate_PartsSet {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      colorId: isSet(object.colorId) ? globalThis.String(object.colorId) : "",
      original: isSet(object.original) ? globalThis.String(object.original) : "",
      itemImageUrl: isSet(object.itemImageUrl) ? globalThis.String(object.itemImageUrl) : "",
    };
  },

  toJSON(message: GachaGetEmissionItemListResponse_GachaItemEmissionRate_PartsSet): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.colorId !== "") {
      obj.colorId = message.colorId;
    }
    if (message.original !== "") {
      obj.original = message.original;
    }
    if (message.itemImageUrl !== "") {
      obj.itemImageUrl = message.itemImageUrl;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GachaGetEmissionItemListResponse_GachaItemEmissionRate_PartsSet>, I>>(
    base?: I,
  ): GachaGetEmissionItemListResponse_GachaItemEmissionRate_PartsSet {
    return GachaGetEmissionItemListResponse_GachaItemEmissionRate_PartsSet.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GachaGetEmissionItemListResponse_GachaItemEmissionRate_PartsSet>, I>>(
    object: I,
  ): GachaGetEmissionItemListResponse_GachaItemEmissionRate_PartsSet {
    const message = createBaseGachaGetEmissionItemListResponse_GachaItemEmissionRate_PartsSet();
    message.id = object.id ?? 0;
    message.colorId = object.colorId ?? "";
    message.original = object.original ?? "";
    message.itemImageUrl = object.itemImageUrl ?? "";
    return message;
  },
};

function createBaseGachaGetEmissionItemListResponse_GachaRarityRate(): GachaGetEmissionItemListResponse_GachaRarityRate {
  return { rarity: 0, emissionRate: 0 };
}

export const GachaGetEmissionItemListResponse_GachaRarityRate = {
  encode(
    message: GachaGetEmissionItemListResponse_GachaRarityRate,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.rarity !== 0) {
      writer.uint32(8).int64(message.rarity);
    }
    if (message.emissionRate !== 0) {
      writer.uint32(17).double(message.emissionRate);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GachaGetEmissionItemListResponse_GachaRarityRate {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGachaGetEmissionItemListResponse_GachaRarityRate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.rarity = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 17) {
            break;
          }

          message.emissionRate = reader.double();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GachaGetEmissionItemListResponse_GachaRarityRate {
    return {
      rarity: isSet(object.rarity) ? globalThis.Number(object.rarity) : 0,
      emissionRate: isSet(object.emissionRate) ? globalThis.Number(object.emissionRate) : 0,
    };
  },

  toJSON(message: GachaGetEmissionItemListResponse_GachaRarityRate): unknown {
    const obj: any = {};
    if (message.rarity !== 0) {
      obj.rarity = Math.round(message.rarity);
    }
    if (message.emissionRate !== 0) {
      obj.emissionRate = message.emissionRate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GachaGetEmissionItemListResponse_GachaRarityRate>, I>>(
    base?: I,
  ): GachaGetEmissionItemListResponse_GachaRarityRate {
    return GachaGetEmissionItemListResponse_GachaRarityRate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GachaGetEmissionItemListResponse_GachaRarityRate>, I>>(
    object: I,
  ): GachaGetEmissionItemListResponse_GachaRarityRate {
    const message = createBaseGachaGetEmissionItemListResponse_GachaRarityRate();
    message.rarity = object.rarity ?? 0;
    message.emissionRate = object.emissionRate ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
